import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

let pendingFastBuySelection = null;
let activeFastBuyProductCard = null;

function productCardMatchesFastBuy(productCard, dataIdAuto) {
  if (!productCard) return false;

  return Array.from(
    productCard.querySelectorAll(
      '.js-button-add-product-to-cart__product-list, ' +
      '.js-button-add-product-to-cart__product-list-mobile'
    )
  ).some(button => button.getAttribute('data-id-auto') === dataIdAuto);
}

function findFastBuyProductCard(dataIdAuto) {
  return Array.from(document.querySelectorAll('.product-item')).find(productCard => {
    return productCardMatchesFastBuy(productCard, dataIdAuto);
  });
}

function resetFastBuySelection(selection) {
  if (!selection) return;

  if (selection.variationName) {
    Array.from(document.getElementsByName(selection.variationName)).forEach(input => {
      input.checked = false;
      input.removeAttribute('checked');
    });
  }

  const productCard = selection.productCard && selection.productCard.isConnected
    ? selection.productCard
    : findFastBuyProductCard(selection.dataIdAuto);
  if (!productCard) return;

  productCard.querySelectorAll('.product-radio-variation input[type="radio"]').forEach(input => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  productCard.querySelectorAll('.product-radio-variation').forEach(variation => {
    variation.classList.remove('select-variation');
  });

  const productWrapper = productCard.querySelector('.product__product_detail_list');
  if (!productWrapper || !selection.productId) return;

  productWrapper.setAttribute('data-id-current', selection.productId);
  productCard.querySelectorAll(
    '.js-button-add-product-to-cart__product-list, ' +
    '.js-button-add-product-to-cart__product-list-mobile'
  ).forEach(button => button.setAttribute('data-id', selection.productId));
}

// A plataforma decide entre abrir o modal e adicionar diretamente no listener
// de clique. O card precisa estar sem uma variação anterior antes dessa decisão.
document.addEventListener('click', function (event) {
  if (!window.matchMedia('(max-width: 991px)').matches) return;

  const buyButton = event.target.closest(
    '.product-item .js-button-add-product-to-cart__product-list, ' +
    '.product-item .js-button-add-product-to-cart__product-list-mobile'
  );

  if (!buyButton) return;

  const productCard = buyButton.closest('.product-item');
  const productWrapper = productCard.querySelector('.product__product_detail_list');
  const standardBuyButton = productCard.querySelector(
    '.js-button-add-product-to-cart__product-list'
  );
  const variationInput = productCard.querySelector(
    '.product-radio-variation input[type="radio"]'
  );
  const selection = {
    dataIdAuto: buyButton.getAttribute('data-id-auto'),
    variationName: variationInput ? variationInput.name : '',
    productId: productWrapper ? productWrapper.getAttribute('data-id') : null,
    productCard,
  };

  activeFastBuyProductCard = productCard;

  const productType = standardBuyButton
    ? standardBuyButton.getAttribute('data-product-type')
    : null;

  if (!buyButton.getAttribute('data-product-type') && productType) {
    buyButton.setAttribute(
      'data-product-type',
      productType
    );
  }

  resetFastBuySelection(selection);

  if (
    variationInput &&
    typeof common_functions !== 'undefined' &&
    typeof common_functions.showQuickPurchaseModal === 'function'
  ) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    common_functions.showQuickPurchaseModal(productCard);
  }
}, true);

function prepareFastBuyPopup(popup) {
  if (!popup || !popup.classList.contains('shoppub-fast-buy-popup')) return;

  // O Slick usa transform e passa a funcionar como referência para position: fixed.
  // Fora dele, o popup volta a ocupar o viewport e também cobre o header.
  if (popup.parentElement !== document.body) {
    document.body.appendChild(popup);
  }

  if (!popup.classList.contains('active')) {
    resetFastBuySelection(pendingFastBuySelection);
    pendingFastBuySelection = null;
    activeFastBuyProductCard = null;
    return;
  }

  const nestedOptions = popup.querySelectorAll('.product-item__content--figure .product-item__options');
  const standaloneOptions = Array.from(popup.querySelectorAll('.product-item__options')).find(
    options => !options.closest('.product-item__content--figure')
  );

  nestedOptions.forEach(element => {
    // Algumas respostas da compra rápida trazem as cores somente dentro da
    // imagem. Antes de eliminar a área duplicada, preserva essas variações.
    if (!standaloneOptions) return;

    if (!standaloneOptions.querySelector('.product__colors')) {
      const colorTitle = element.querySelector('.product__colors__title');
      const colorOptions = element.querySelector('.product__colors');

      if (colorOptions) standaloneOptions.prepend(colorOptions);
      if (colorTitle) standaloneOptions.prepend(colorTitle);
    }

    element.remove();
  });
}

function normalizeProductItemCaption(productCard) {
  if (!productCard) return;

  const figure = productCard.querySelector('.product-item__content--figure');
  const productInfo = productCard.querySelector('.info-product');
  if (!figure || !productInfo) return;

  let currentCaption = productInfo.querySelector('.product-item__content--figcaption');
  const nestedCaptions = Array.from(figure.children).filter(element => {
    return element.classList.contains('product-item__content--figcaption');
  });

  nestedCaptions.forEach(caption => {
    if (currentCaption && currentCaption !== caption) {
      caption.remove();
      return;
    }

    productInfo.prepend(caption);
    currentCaption = caption;
  });
}

const fastBuyObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes') {
      prepareFastBuyPopup(mutation.target);
      return;
    }

    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;

      const productCard = node.closest('.product-item');
      if (productCard) normalizeProductItemCaption(productCard);
      node.querySelectorAll('.product-item').forEach(normalizeProductItemCaption);

      if (node.matches('.shoppub-fast-buy-popup')) {
        prepareFastBuyPopup(node);
      }

      node.querySelectorAll('.shoppub-fast-buy-popup').forEach(prepareFastBuyPopup);
    });
  });
});

fastBuyObserver.observe(document.body, {
  attributes: true,
  attributeFilter: ['class'],
  childList: true,
  subtree: true,
});

document.querySelectorAll('.product-item').forEach(normalizeProductItemCaption);
document.querySelectorAll('.shoppub-fast-buy-popup').forEach(prepareFastBuyPopup);

// No mobile, a escolha do tamanho conclui a compra rápida. O botão continua
// no DOM para preservar o fluxo nativo da plataforma, mas fica oculto no modal.
document.body.addEventListener('change', function (event) {
  if (!window.matchMedia('(max-width: 991px)').matches) return;

  const sizeInput = event.target.closest(
    '.shoppub-fast-buy-popup .product-radio-variation input[type="radio"]'
  );

  if (!sizeInput) return;

  const popup = sizeInput.closest('.shoppub-fast-buy-popup');
  const sizeLabel = popup.querySelector(`label[for="${sizeInput.id}"]`);

  if (!sizeLabel || sizeLabel.classList.contains('out-of-stock')) return;

  window.setTimeout(function () {
    const buyButton = popup.querySelector('.js-button-add-product-to-cart__product-list');
    if (!buyButton) return;

    const dataIdAuto = buyButton.getAttribute('data-id-auto');
    const productCard = productCardMatchesFastBuy(activeFastBuyProductCard, dataIdAuto)
      ? activeFastBuyProductCard
      : findFastBuyProductCard(dataIdAuto);
    const productWrapper = productCard
      ? productCard.querySelector('.product__product_detail_list')
      : null;
    const selection = {
      dataIdAuto,
      variationName: sizeInput.name,
      productId: productWrapper ? productWrapper.getAttribute('data-id') : null,
      productCard,
    };

    pendingFastBuySelection = selection;
    buyButton.click();

    // O clique nativo lê a variação de forma síncrona. Depois disso, o card
    // deve voltar ao estado inicial para a próxima compra abrir o modal.
    window.setTimeout(function () {
      resetFastBuySelection(selection);
    }, 0);
  }, 500);
});

document.addEventListener("DOMContentLoaded", function () {

  // Troca label do brinde de "BRINDE GRÁTIS" para "PRESENTE" no carrinho da plataforma
  const replaceGiftBadgeLabels = () => {
    document.querySelectorAll('.shoppub-side-cart-list-item--auto-gift .auto-gift-card__badge').forEach(badge => {
      if (badge.textContent.trim() !== 'PRESENTE') {
        badge.textContent = 'PRESENTE';
      }
    });
  };

  const giftBadgeObserver = new MutationObserver(replaceGiftBadgeLabels);
  const sideCart = document.querySelector('.shoppub-side-cart');
  giftBadgeObserver.observe(sideCart || document.body, { childList: true, subtree: true });

  const currentPath = window.location.pathname.replace(/\/+$/, '');
  const isInstitutionalAboutPage = currentPath.endsWith('/institucional/quem-somos');
  if (currentPath.endsWith('/pagina/quem-somos') || isInstitutionalAboutPage) {
    document.querySelector('body').classList.add('page-front');
    const template = document.getElementById('dynamic-template-quem-somos');
    const replaceContent = isInstitutionalAboutPage
      ? document.querySelector('#dynamic-page .main-content > .container-shoppub')
      : document.getElementById('replace-content') ||
      document.querySelector('#dynamic-page-extra .main-content .container-shoppub .page-custom');

    if (template && replaceContent) {
      const content = template.content.cloneNode(true);
      replaceContent.innerHTML = '';
      replaceContent.appendChild(content);

      const shoppubVideos = [];
      const playVideo = function (video) {
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => { });
      };
      const videoObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) playVideo(entry.target);
          });
        }, { threshold: 0.1 })
        : null;

      replaceContent.querySelectorAll('.quem-somos__media--shoppub').forEach((videoContainer) => {
        const videoSource = videoContainer.dataset.videoSrc.trim();
        if (!videoSource) return;

        const video = document.createElement('video');
        video.className = 'quem-somos__video';
        video.defaultMuted = true;
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.loop = videoContainer.dataset.videoLoop === 'true';
        video.preload = 'auto';
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.src = videoSource;

        videoContainer.prepend(video);
        shoppubVideos.push(video);
        video.addEventListener('canplay', () => playVideo(video), { once: true });
        playVideo(video);

        if (videoObserver) videoObserver.observe(video);
      });

      const videoEmbeds = replaceContent.querySelectorAll('.quem-somos__media--embed');

      videoEmbeds.forEach((videoEmbed) => {
        const mediaType = videoEmbed.dataset.videoProvider;
        const configuredVideo = videoEmbed.dataset.videoUrl.trim();
        let videoId = configuredVideo;

        if (configuredVideo) {
          try {
            const parsedVideoUrl = new URL(configuredVideo);

            if (mediaType === 'video-youtube') {
              videoId = parsedVideoUrl.hostname.includes('youtu.be')
                ? parsedVideoUrl.pathname.split('/').filter(Boolean)[0]
                : parsedVideoUrl.searchParams.get('v') ||
                parsedVideoUrl.pathname.split('/').filter(Boolean).pop();
            } else {
              videoId = parsedVideoUrl.pathname
                .split('/')
                .filter(Boolean)
                .find((pathPart) => /^\d+$/.test(pathPart));
            }
          } catch (error) {
            videoId = configuredVideo;
          }

          if (videoId) {
            const iframe = document.createElement('iframe');
            iframe.className = 'quem-somos__video';
            iframe.title = 'Vídeo do ateliê Brogan';
            iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
            iframe.setAttribute('allowfullscreen', '');
            iframe.src = mediaType === 'video-youtube'
              ? `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&controls=0&rel=0&playsinline=1`
              : `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&muted=1&controls=0&title=0&byline=0&portrait=0`;
            videoEmbed.appendChild(iframe);
          }
        }
      });

      replaceContent.querySelectorAll('.quem-somos__mute').forEach((muteButton) => {
        const video = muteButton.closest('.quem-somos__media').querySelector('video');

        if (!video) return;

        muteButton.addEventListener('click', function () {
          video.muted = !video.muted;
          muteButton.setAttribute('aria-pressed', String(!video.muted));
          muteButton.setAttribute('aria-label', video.muted ? 'Ativar som do vídeo' : 'Desativar som do vídeo');

          if (video.paused) {
            const playPromise = video.play();
            if (playPromise) playPromise.catch(() => { });
          }
        });
      });
    }
  }

  if (currentPath.endsWith('/pagina/loafer-pierre')) {
    document.querySelector('body').classList.add('page-front');
    const template = document.getElementById('dynamic-template-loafer-pierre');
    const replaceContent = document.getElementById('replace-content') ||
      document.querySelector('#dynamic-page-extra .main-content .container-shoppub .page-custom') ||
      document.querySelector('#dynamic-page-extra .main-content > .container-shoppub');

    if (template && replaceContent) {
      replaceContent.innerHTML = '';
      replaceContent.appendChild(template.content.cloneNode(true));

      const playVideo = function (video) {
        const playPromise = video.play();
        if (playPromise) playPromise.catch(() => { });
      };

      replaceContent.querySelectorAll('.loafer-pierre__hero--shoppub').forEach((videoContainer) => {
        const isMobile = window.matchMedia('(max-width: 991px)').matches;
        const videoSource = (isMobile
          ? videoContainer.dataset.videoSrcMobile
          : videoContainer.dataset.videoSrc).trim();
        if (!videoSource) return;

        const video = document.createElement('video');
        video.className = 'loafer-pierre__hero-media';
        video.defaultMuted = true;
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.loop = true;
        video.preload = 'auto';
        video.setAttribute('muted', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.src = videoSource;

        videoContainer.appendChild(video);
        video.addEventListener('canplay', () => playVideo(video), { once: true });
        playVideo(video);
      });

      replaceContent.querySelectorAll('.loafer-pierre__hero--embed').forEach((videoContainer) => {
        const mediaType = videoContainer.dataset.videoProvider;
        const isMobile = window.matchMedia('(max-width: 991px)').matches;
        const configuredVideo = (isMobile
          ? videoContainer.dataset.videoUrlMobile
          : videoContainer.dataset.videoUrl).trim();
        let videoId = configuredVideo;

        if (!configuredVideo) return;

        try {
          const parsedVideoUrl = new URL(configuredVideo);

          if (mediaType === 'video-youtube') {
            videoId = parsedVideoUrl.hostname.includes('youtu.be')
              ? parsedVideoUrl.pathname.split('/').filter(Boolean)[0]
              : parsedVideoUrl.searchParams.get('v') ||
              parsedVideoUrl.pathname.split('/').filter(Boolean).pop();
          } else {
            videoId = parsedVideoUrl.pathname
              .split('/')
              .filter(Boolean)
              .find((pathPart) => /^\d+$/.test(pathPart));
          }
        } catch (error) {
          videoId = configuredVideo;
        }

        if (!videoId) return;

        const iframe = document.createElement('iframe');
        iframe.className = 'loafer-pierre__hero-media';
        iframe.title = 'Vídeo Loafer Pierre';
        iframe.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        iframe.src = mediaType === 'video-youtube'
          ? `https://www.youtube.com/embed/${encodeURIComponent(videoId)}?autoplay=1&mute=1&loop=1&playlist=${encodeURIComponent(videoId)}&controls=0&rel=0&playsinline=1`
          : `https://player.vimeo.com/video/${encodeURIComponent(videoId)}?autoplay=1&muted=1&loop=1&background=1&controls=0&title=0&byline=0&portrait=0`;
        videoContainer.appendChild(iframe);
      });

      const loaferPierre = replaceContent.querySelector('.loafer-pierre');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobileCarouselMedia = window.matchMedia('(max-width: 991px)');

      const updateLoaferPierreCarousels = function () {
        if (!loaferPierre || !window.jQuery || !window.jQuery.fn.slick) return;

        const carouselSettings = [
          {
            element: loaferPierre.querySelector('.loafer-pierre__tones'),
            options: {
              adaptiveHeight: true,
              dots: true,
              slidesToShow: 1.12
            }
          },
          {
            element: loaferPierre.querySelector('.loafer-pierre__edition-gallery'),
            options: {
              adaptiveHeight: false,
              dots: false,
              slidesToShow: 1.12
            }
          }
        ];

        carouselSettings.forEach((carousel) => {
          if (!carousel.element) return;

          const slider = window.jQuery(carousel.element);
          const initialized = slider.hasClass('slick-initialized');

          if (mobileCarouselMedia.matches && !initialized && carousel.element.children.length > 1) {
            slider.slick(window.jQuery.extend({
              arrows: false,
              infinite: false,
              mobileFirst: true,
              slidesToScroll: 1,
              speed: reduceMotion.matches ? 0 : 500,
              swipeToSlide: true,
              touchThreshold: 100,
              cssEase: 'ease-in-out'
            }, carousel.options));
          } else if (!mobileCarouselMedia.matches && initialized) {
            slider.slick('unslick');
          }
        });

        if (window.ScrollTrigger) {
          window.requestAnimationFrame(() => window.ScrollTrigger.refresh());
        }
      };

      updateLoaferPierreCarousels();

      if (mobileCarouselMedia.addEventListener) {
        mobileCarouselMedia.addEventListener('change', updateLoaferPierreCarousels);
      } else {
        mobileCarouselMedia.addListener(updateLoaferPierreCarousels);
      }

      if (loaferPierre && window.gsap && window.ScrollTrigger && !reduceMotion.matches) {
        window.gsap.registerPlugin(window.ScrollTrigger);

        const animatedBlocks = Array.from(loaferPierre.querySelectorAll([
          '.loafer-pierre__hero',
          '.loafer-pierre__intro',
          '.loafer-pierre__products',
          '.loafer-pierre__story',
          '.loafer-pierre__detail',
          '.loafer-pierre__tones',
          '.loafer-pierre__edition'
        ].join(',')));

        animatedBlocks.forEach((block) => {
          window.gsap.fromTo(block, {
            autoAlpha: 0
          }, {
            autoAlpha: 1,
            duration: 0.9,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: block,
              start: 'top 88%',
              toggleActions: 'play none none reverse'
            }
          });
        });

        loaferPierre.querySelectorAll('img').forEach((image) => {
          if (!image.complete) {
            image.addEventListener('load', () => window.ScrollTrigger.refresh(), { once: true });
          }
        });

        window.requestAnimationFrame(() => window.ScrollTrigger.refresh());
      }
    }
  }

  // Página dinâmica: injeta conteúdo somente quando a URL for /pagina/teste/
  (function loadDynamicTestPage() {
    const currentPath = window.location.pathname;
    if (!currentPath.includes('/pagina/pais-2026/')) return;

    const template = document.getElementById('dynamic-template-teste');
    if (!template) return;

    // Alvo de injeção: usa #replace-content se existir, senão cai no container da página
    const target =
      document.getElementById('replace-content') ||
      document.querySelector('#dynamic-page-extra .main-content .container-shoppub') ||
      document.querySelector('.main-content .container-shoppub') ||
      document.querySelector('.main-content');

    if (!target) return;

    target.innerHTML = '';
    target.appendChild(template.content.cloneNode(true));

    // Aplica a classe .page-front no container ANTES de inicializar o slick. Sem isso,
    // o slick media o container estreito (padrão) e só corrigia as larguras num resize
    // (~1s depois), pois .page-front (width/max-width:100%; padding:0) era adicionada
    // apenas mais tarde, depois do slick já ter medido.
    var containerFront = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
    if (containerFront && target.querySelector('.page-extra-content')) {
      containerFront.classList.add('page-front');
    }

    // Vídeo Shoppub (upload): força o (re)carregamento após clonar do <template>.
    // O <source> clonado de um template inerte nem sempre inicia a seleção de recurso
    // sozinho, então chamamos load()/play() — igual ao empurrão que os iframes recebem.
    target.querySelectorAll('video').forEach(function (video) {
      video.load();
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () { });
      }
    });

    // Botão de áudio do vídeo Shoppub: começa mutado e alterna o som no clique
    target.querySelectorAll('.page-video-section-video-sound').forEach(function (btn) {
      var video = btn.parentElement.querySelector('video');
      if (!video) return;
      video.muted = true;
      btn.classList.add('is-muted');
      btn.addEventListener('click', function () {
        video.muted = !video.muted;
        btn.classList.toggle('is-muted', video.muted);
        btn.setAttribute('aria-pressed', String(!video.muted));
        if (!video.muted) {
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function () { }); }
        }
      });
    });

    // Scroll suave com easing manual (requestAnimationFrame). Usado só no mobile, onde o
    // `behavior: 'smooth'` nativo costuma sair abrupto/travado; duração maior + ease-in-out
    // deixam o movimento mais macio.
    const smoothScrollTo = function (top, duration) {
      const start = window.pageYOffset;
      const change = top - start;
      const startTime = performance.now();
      const easeInOutCubic = function (t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      };
      const animate = function (now) {
        const progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, start + change * easeInOutCubic(progress));
        if (progress < 1) requestAnimationFrame(animate);
      };
      requestAnimationFrame(animate);
    };

    // Botão institucional (.btn-link): quando o href aponta para uma âncora da própria
    // página, rola suavemente até ela em vez do salto padrão, descontando a altura do
    // header fixo (#app_header). Links externos/sem âncora seguem o comportamento normal.
    target.querySelectorAll('.btn-link').forEach(function (link) {
      link.addEventListener('click', function (e) {
        const hash = link.hash;
        if (!hash || hash === '#') return;

        let destino = document.getElementById(hash.slice(1));
        if (!destino) {
          try { destino = document.getElementById(decodeURIComponent(hash.slice(1))); } catch (err) { }
        }
        if (!destino) return;

        e.preventDefault();

        const header = document.getElementById('app_header');
        const offset = header ? header.offsetHeight : 0;
        const top = destino.getBoundingClientRect().top + window.pageYOffset - offset;

        // Só no mobile usa o easing manual (mais macio); no desktop mantém o nativo.
        if (window.matchMedia('(max-width: 991px)').matches) {
          smoothScrollTo(top, 900);
        } else {
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    // Normaliza a URL colada (watch, youtu.be, vimeo.com/ID, embed, etc) para a URL de embed
    target.querySelectorAll('.js-embed-video').forEach(function (iframe) {
      const rawUrl = iframe.getAttribute('data-video-url');
      const videoType = iframe.getAttribute('data-video-type');
      if (!rawUrl) return;

      let embedSrc = '';

      if (videoType === 'video-youtube') {
        const match = rawUrl.match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
        const videoId = match ? match[1] : null;
        if (videoId) {
          embedSrc = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&loop=1&playlist=${videoId}&controls=0&rel=0&modestbranding=1`;
        }
      } else if (videoType === 'video-vimeo') {
        const match = rawUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
        const videoId = match ? match[1] : null;
        if (videoId) {
          embedSrc = `https://player.vimeo.com/video/${videoId}?autoplay=1&muted=1&loop=1&background=1`;
        }
      }

      // Se não reconheceu o formato, usa a URL como veio (pode já estar no formato de embed)
      iframe.src = embedSrc || rawUrl;
    });

    // Carrossel de produtos: 1 no mobile, 4 no desktop
    if (target.querySelector('#page-products-slider')) {
      $('#page-products-slider').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 991,
            settings: 'unslick'
          }
        ]
      });

      // Reforço: recalcula as posições quando as imagens/recursos terminarem de carregar
      // (caso a barra de rolagem apareça e altere a largura útil do container).
      $(window).on('load', function () {
        $('#page-products-slider').slick('setPosition');
      });
    }

    // Carrossel de looks: 1 no mobile, 3 no tablet, grid (via CSS) no desktop
    if (target.querySelector('.woman-look-items')) {
      $('.woman-look-items').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 7,
              slidesToScroll: 1,
              arrows: true,
            }
          }
        ]
      });
    }

    if ($('.woman-look-items')) {
      $('.woman-look-items').slick({
        swipeToSlide: true,
        touchThreshold: 100,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 300,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          },
          {
            breakpoint: 991,
            settings: 'unslick'
          }
        ]
      });
    }
  })();

  const containerShoppub = document.querySelector('#dynamic-page-extra .main-content .container-shoppub');
  if (containerShoppub) {
    const pageCustom = document.querySelector('#dynamic-page-extra .page-custom');
    if (pageCustom) {
      containerShoppub.classList.add('page-front');
    }
  }
  if (containerShoppub) {
    const pageExtraTemas = document.querySelector('#dynamic-page-extra .page-extra-content');
    const machOne = document.querySelector('#dynamic-page-extra .mach-one');
    const womanCollection = document.querySelector('#dynamic-page-extra .woman-collection');
    if (pageExtraTemas) {
      containerShoppub.classList.add('page-front');
    }
    if (womanCollection) {
      containerShoppub.classList.add('page-front');

      const newsLetter = document.querySelector('#dynamic-page-extra .newsletter');
      if (newsLetter) {
        newsLetter.style.display = 'none';
      }

      if ($('#product_list-page')) {
        $('#product_list-page').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          arrows: false,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 991,
              settings: {
                arrows: true,
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            }
          ]
        });
      }

      if ($('.brogan-woman__images')) {
        $('.brogan-woman__images').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          arrows: false,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          responsive: [
            {
              breakpoint: 1024,
              settings: 'unslick'
            }
          ]
        });
      }

      if ($('.woman-look-items')) {
        $('.woman-look-items').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          arrows: false,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 991,
              settings: 'unslick'
            }
          ]
        });
      }

      if ($('.woman-shoes-images')) {
        $('.woman-shoes-images').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          arrows: false,
          dots: false,
          infinite: false,
          mobileFirst: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 300,
          responsive: [
            {
              breakpoint: 1024,
              settings: 'unslick'
            }
          ]
        });
      }


      const btnTop = document.getElementById('btn-top-fixed');
      const triggerSection = document.querySelector('.products-list');

      if (!btnTop || !triggerSection) return;

      function checkScroll() {
        const triggerSectionTop = triggerSection.offsetTop;
        const triggerSectionBottom = triggerSectionTop + triggerSection.offsetHeight;
        const scrollPosition = window.pageYOffset;

        // Mostra o botão apenas quando o usuário passar completamente da seção
        if (scrollPosition > triggerSectionBottom) {
          btnTop.classList.add('show');
        } else {
          btnTop.classList.remove('show');
        }
      }

      window.addEventListener('scroll', checkScroll);

      checkScroll();

      // Smooth scroll para o topo quando clicar no botão
      btnTop.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });

    }
    if (machOne) {
      containerShoppub.classList.add('page-front');

      waitForElementToExist('.mach-one-products__list').then(element => {
        $('.mach-one-products__list').slick({
          dots: false,
          infinite: false,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 5000,
              }
            },
          ]
        });
      });

      waitForElementToExist('.mach-one-outit__image').then(element => {
        $('.mach-one-outit__image').slick({
          dots: false,
          infinite: false,
          speed: 1000,
          slidesToShow: 1,
          slidesToScroll: 1,
          mobileFirst: true,
          arrows: false,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 991,
              settings: "unslick"
            },
          ]
        });
      });

      const btnTop = document.getElementById('btn-top-fixed');
      const triggerSection = document.querySelector('.mach-one-products');

      if (!btnTop || !triggerSection) return;

      function checkScroll() {
        const triggerSectionTop = triggerSection.offsetTop;
        const triggerSectionBottom = triggerSectionTop + triggerSection.offsetHeight;
        const scrollPosition = window.pageYOffset;

        // Mostra o botão apenas quando o usuário passar completamente da seção
        if (scrollPosition > triggerSectionBottom) {
          btnTop.classList.add('show');
        } else {
          btnTop.classList.remove('show');
        }
      }

      window.addEventListener('scroll', checkScroll);

      checkScroll();

      // Smooth scroll para o topo quando clicar no botão
      btnTop.addEventListener('click', function (e) {
        e.preventDefault();
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    }
  }

  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {
    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var $el = $(el);
      if ($el.visible(true)) {
        $el.addClass("widget-loaded");
        $el.children().trigger("mouseenter");

        setTimeout(() => {
          const domEl = el;
          const appendColors = domEl.querySelector('#append-colors');
          const colorsVariation = domEl.querySelector('.product__colors');

          if (appendColors && colorsVariation) {
            const cloneColorsVariation = colorsVariation.cloneNode(true);
            appendColors.appendChild(cloneColorsVariation);
          }
        }, 1000);

        $el.on("click", "input[id^='product_item_variation__product_detail']", function () {
          var input = $(this);
          var inputId = input.attr("id");
          var label = $el.find("label[for='" + inputId + "']");

          if (label.length && !label.hasClass("out-of-stock")) {
            setTimeout(function () {
              $el.find(".js-button-add-product-to-cart__product-list").trigger("click");
            }, 500);
          }
        });
      }
    });
  }

  // Adicionar mais eventos para melhor compatibilidade mobile
  $(window).on('scroll mousemove touchstart touchmove touchend', function () {
    loadWidgets();
  });

  // Garante execução no mobile após layout completo
  $(window).on('load', function () {
    setTimeout(loadWidgets, 300);
  });


  function moveThumbs() {
    if ($('.product-detail__header--photoArea-thumbs-default') && $('#product-photo')) {
      document.querySelectorAll('.product-detail__header--photoArea-thumbs-default li').forEach((thumb, index) => {
        thumb.addEventListener('click', () => {
          const targetLi = document.querySelectorAll('#product-photo li')[index];
          if (targetLi) {
            targetLi.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
      });
    }
  }
  moveThumbs()

  function loadSvg() {
    const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function (svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstInteraction() {
    loadSvg();
    window.removeEventListener('scroll', onFirstInteraction);
    window.removeEventListener('mousemove', onFirstInteraction);
  }

  window.addEventListener('scroll', onFirstInteraction, { passive: true });
  window.addEventListener('mousemove', onFirstInteraction, { passive: true });

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });

  // Adicionar evento específico para quando a página terminar de carregar
  $(document).ready(function () {
    loadWidgets();
  });

  function formatProductItemPrice(value) {
    if (value === null || value === undefined || value === '') return '';

    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return '';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(numericValue).replace(/\u00a0/g, ' ');
  }

  function updateProductItemPrice(parent, productData) {
    const priceContent = parent.querySelector('.price .price-content');
    if (!priceContent) return;

    const oldPriceValue = Number(productData.preco_de);
    const oldPrice = Number.isFinite(oldPriceValue) && oldPriceValue > 0
      ? formatProductItemPrice(oldPriceValue)
      : '';
    const fullPrice = formatProductItemPrice(productData.preco_cheio);

    if (!oldPrice && !fullPrice) return;

    priceContent.textContent = '';

    if (oldPrice) {
      const oldPriceElement = document.createElement('span');
      oldPriceElement.className = 'price-of';
      oldPriceElement.textContent = oldPrice;
      priceContent.appendChild(oldPriceElement);
    }

    if (fullPrice) {
      const fullPriceElement = document.createElement('span');
      fullPriceElement.className = 'in-cash';
      fullPriceElement.textContent = fullPrice;
      priceContent.appendChild(fullPriceElement);
    }
  }

  function selectVariation(id, parent) {
    axios.get(`/api/front/product/${id}/get-linked-product/`).then(res => {
      const isProductItem = parent.classList.contains('product-item') ? true : false;
      const isModalPopup = parent.classList.contains('shoppub-fast-buy-popup') ? true : false;
      let productName = '';
      let radioVariations = '';
      let getBody = '';
      let dataIdAuto = '';
      //seleciona os elementos a serem alterados
      if (isProductItem) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = radioVariations && radioVariations.querySelector('input') ? radioVariations.querySelector('input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else if (isModalPopup) {
        productName = parent.querySelector('.product-item__content--figcaption-name a');
        radioVariations = parent.querySelector(".product-radio-variation");
        getBody = parent.firstElementChild;
        dataIdAuto = parent.querySelector('.product-radio-variation input') ? parent.querySelector('.product-radio-variation input').getAttribute('data-id-auto') : '';
        const buttonId = parent.querySelector('.js-button-add-product-to-cart__product-list');
        if (buttonId) {
          buttonId.setAttribute('data-id', res.data.id);
        }
      } else {
        productName = parent.querySelector('#js-product_name__product_detail_');
        radioVariations = parent.querySelector(".product-detail__header--infoArea-kit .product-radio-variation");
        getBody = document.querySelector('body');
      }

      const linkName = "/produto/" + res.data.slug;
      //troca o nome do produto
      if (productName) {
        productName.innerHTML = res.data.name
        if (productName.tagName.toLowerCase() === 'a') {
          //substitui o link href da tag a (ainda experimental pois há variaveis, nao funciona sempre)
          productName.href = linkName;
        }
      }

      if (res.data.variations.length > 0) {
        $(radioVariations).html('');
        if (radioVariations && !isProductItem) {
          $(radioVariations).append('<p class="label_attributes"> escolha o tamanho </p>');
        }
        res.data.variations.forEach(function (variation) {
          const radioInput = $(`<input type="radio" name="product_item_variation__product_detail_${dataIdAuto}_${res.data.id}" id="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" value="${variation.id}" data-id-auto="${dataIdAuto}" data-variation-name="${variation.main_attribute.name}" data-origin-location="product_detail">`);

          const radioLabel = $(`<label for="product_item_variation__product_detail_${dataIdAuto}_${variation.id}" class="label_radio ${!variation.available ? "out-of-stock" : ""} radio"><span>${variation.main_attribute.value}</span></label>`);

          radioLabel.on('click', function () {
            getBody.setAttribute('data-id-current', variation.id)
          });

          $(radioVariations).append(radioInput).append(radioLabel);
        })
      }

      if (isProductItem) {
        const figure = parent.querySelector('.product-item__content .product-item__content--figure a');
        updateProductItemPrice(parent, res.data);

        if (figure) figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else if (isModalPopup) {
        const figure = parent.querySelector('.product-item__content--figure a');
        figure.href = linkName;

        if (figure) { // Verifique se figure não é null
          figure.innerHTML = ''; // Limpa o conteúdo existente
          if (res.data.images.length > 0) {
            figure.innerHTML = `<a href="${linkName}" class="w-100"><img src="${res.data.images[0]}" alt="${res.data.name}" class="block-img lazy-img no-hover b-error"> <span class="product-item__content--figure-loading"></span></a>`;
          }
        }
      } else {
        const keepBuyingName = document.querySelector('#js-product_name__product_detail_keeping_buying');
        const keepBuyingImage = document.querySelector('.keeping-buying__figure--image');

        if (keepBuyingName && keepBuyingImage) {
          keepBuyingName.innerHTML = res.data.name;
          keepBuyingImage.setAttribute('src', `${res.data.images[0]}`);
        }

        if ($('.mobile-slider .slider-single').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-single').slick('unslick');
        }
        if ($('.mobile-slider .slider-nav').hasClass('slick-initialized')) {
          $('.mobile-slider .slider-nav').slick('unslick');
        }

        $('.product-detail__header--photoArea-mobile').slick('removeSlide', null, null, true);
        $('.product-detail__header--photoArea-photo ul').html('');
        $('.product-detail__header--photoArea-thumbs-default ul').html('');
        $('.mobile-slider .slider-single').html('');
        $('.mobile-slider .slider-nav').html('');
        if (res.data.images.length > 0) {
          res.data.images.forEach(function (image, index) {
            $('.product-detail__header--photoArea-mobile').slick('slickAdd', `<li style="width: 100%;"><a href="${image}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-photo ul').append(`<li class="sp-wrap" id="photo-${index}"><a href="${image}" data-gallery="gallery1"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></a></li>`);
            $('.product-detail__header--photoArea-thumbs-default ul').append(`<li class="sp-wrap" id="photo-${index}"><img src="${image}" class="product-detail__header--photoArea-mobile-img"/></li>`);
            $('.mobile-slider .slider-single').append(`<a href="${image}" data-gallery="gallery3"><img src="${image}"/></a>`);
            $('.mobile-slider .slider-nav').append(`<li><img src="${image}"/></li>`);
          });
        }

        moveThumbs();

        $('.mobile-slider .slider-single').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          fade: false,
          infinite: false,
          mobileFirst: true,
          speed: 700,
          cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
          vertical: false,
          responsive: [
            {
              breakpoint: 991,
              settings: "unslick"
            },
          ]
        });

        $('.mobile-slider .slider-nav').slick({
          swipeToSlide: true,
          touchThreshold: 100,
          slidesToShow: 4, // ou quantas thumbs quiser mostrar
          slidesToScroll: 1,
          asNavFor: '.slider-single',
          focusOnSelect: true,
          centerMode: false, // opcional
          arrows: false, // ou false se quiser ocultar as setas
          infinite: false,
          mobileFirst: true,
          speed: 700,
          cssEase: 'cubic-bezier(0.22, 1, 0.36, 1)',
          vertical: false,
          responsive: [
            {
              breakpoint: 991,
              settings: "unslick"
            },
          ]
        });
      }

      if (getBody) {
        getBody.setAttribute('data-id', `${id}`);
        getBody.setAttribute('data-id-current', `${id}`);
      }
    }).catch(err => { console.log(err); });
  }

  document.body.addEventListener('click', function (event) {
    const clickedColor = event.target.closest('.product__colors-item, .product__colors-box');
    if (!clickedColor) return;

    const isProductItem = !!event.target.closest('.product-item');
    const isModalPopup = !!event.target.closest('.shoppub-fast-buy-popup');

    if (isProductItem || isModalPopup) {
      event.preventDefault();

      const productItem = isProductItem
        ? (event.target.closest('.product-item') || event.target.closest('.product-detail__header'))
        : event.target.closest('.shoppub-fast-buy-popup');

      const targetColor = clickedColor.classList.contains('product__colors-item')
        ? clickedColor
        : clickedColor.closest('.product__colors-item');

      if (!productItem || !targetColor) return;

      const selected = targetColor.getAttribute('variation-id');
      const allColorOptions = productItem.querySelectorAll('.product__colors-item');
      allColorOptions.forEach(option => {
        option.classList.toggle('is-selected', option.getAttribute('variation-id') === selected);
      });

      selectVariation(selected, productItem);
    }
  });

  if (view_origin === 'checkout') {
    // Observer para quando .order-bump receber a classe 'loaded'
    const observedElements = new WeakSet();

    const orderBumpObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.classList.contains('loaded')) {
            const productItem = document.querySelector('.product-item');
            if (productItem && typeof $ !== 'undefined') {
              $(productItem).children().trigger("mouseenter");
            }
          }
        }
      });
    });

    // Observer para detectar quando novos elementos .order-bump são adicionados ao DOM
    const containerObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          // Verifica se algum nó adicionado é um .order-bump ou contém um
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) { // Element node
              let orderBump = null;
              if (node.classList && node.classList.contains('order-bump')) {
                orderBump = node;
              } else {
                orderBump = node.querySelector && node.querySelector('.order-bump');
              }

              if (orderBump && !observedElements.has(orderBump)) {
                observedElements.add(orderBump);
                orderBumpObserver.observe(orderBump, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }
            }
          });
        }
      });
    });

    // Inicia a observação do container e dos elementos existentes
    const startObserving = () => {
      // Observa o body ou um container específico para detectar novos elementos
      const container = document.querySelector('.checkout-step__3') || document.body;
      if (container) {
        containerObserver.observe(container, {
          childList: true,
          subtree: true
        });

        // Observa elementos .order-bump que já existem
        const existingOrderBumps = document.querySelectorAll('.order-bump');
        existingOrderBumps.forEach(function (orderBump) {
          if (!observedElements.has(orderBump)) {
            observedElements.add(orderBump);
            orderBumpObserver.observe(orderBump, {
              attributes: true,
              attributeFilter: ['class']
            });
          }
        });
      } else {
        // Se não encontrar o container, tenta novamente após um delay
        setTimeout(startObserving, 100);
      }
    };

    startObserving();
  }

});
